const initialState = {
    //list branch
    loadingBranchList: false,
    BranchListError: "",
    BranchList: [],

    //view customer
    loadingBranchDetail: false,
    BranchDetailError: "",
    BranchDetail: [],

    //view custome details
    loadingBranchCustomDetail: false,
    BranchCustomDetailError: "",
    BranchCustomDetail: {},

    //view custome bank list
    loadingBranchCustomBankList: false,
    BranchCustomBankListError: "",
    BranchCustomBankList: [],

    //view custome bank detail
    loadingBranchCustomBankDetail: false,
    BranchCustomBankDetailError: "",
    BranchCustomBankDetail: [],

    //country
    loadingBranchCountryApi: false,
    BranchCountryDataError: "",
    BranchCountryData: [],

    //state
    loadingBranchStateApi: false,
    BranchStateDataError: "",
    BranchStateData: [],

    //city
    loadingBranchCityApi: false,
    BranchCityDataError: "",
    BranchCityData: [],

    //airport
    loadingBranchAirportApi: false,
    BranchAirportDataError: "",
    BranchAirportData: [],

    //seaport
    loadingBranchSeaportApi: false,
    BranchSeaportDataError: "",
    BranchSeaportData: [],




    // <----------------More Address-------------------->
    //list more address
    loadingBranchMoreAddressList: false,
    BranchMoreAddressListError: "",
    BranchMoreAddressList: [],


    //view more address
    loadingBranchMoreAddressDetail: false,
    BranchMoreAddressDetailError: "",
    BranchMoreAddressDetail: [],


    //account manager
    loadingBranchAccManagers: false,
    BranchAccManagersDataError: "",
    BranchAccManagersData: [],

    //account manager detail
    loadingBranchAccManagerDetail: false,
    BranchAccManagerDetailDataError: "",
    BranchAccManagerDetailData: {},


}

const BranchReducer = (state = initialState, action) => {
    switch (action.type) {

        //list branch//
        case 'FIND_BRANCH_LIST_REQUEST':
            return {
                ...state,
                loadingBranchList: true,
                BranchList: "",
                BranchListError: '',
            };
        case 'FIND_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingBranchList: false,
                BranchList: action.payload,
            };
        case 'FIND_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingBranchList: false,
                BranchListError: action.payload,
            };
        //list branch//

        //view branch//
        case 'FIND_BRANCH_DETAIL_REQUEST':
            return {
                ...state,
                loadingBranchDetail: true,
                BranchDetail: "",
                BranchDetailError: '',
            };
        case 'FIND_BRANCH_DETAIL_SUCCESS':
            return {
                ...state,
                loadingBranchDetail: false,
                BranchDetail: action.payload,
            };
        case 'FIND_BRANCH_DETAIL_FAILURE':
            return {
                ...state,
                loadingBranchDetail: false,
                BranchDetailError: action.payload,
            };
        //view branch//

        //view custom branch//
        case 'FIND_BRANCH_CUSTOM_DETAIL_REQUEST':
            return {
                ...state,
                loadingBranchCustomDetail: true,
                BranchCustomDetail: {},
                BranchCustomDetailError: '',
            };
        case 'FIND_BRANCH_CUSTOM_DETAIL_SUCCESS':
            return {
                ...state,
                loadingBranchCustomDetail: false,
                BranchCustomDetail: action.payload,
            };
        case 'FIND_BRANCH_CUSTOM_DETAIL_FAILURE':
            return {
                ...state,
                loadingBranchCustomDetail: false,
                BranchCustomDetailError: action.payload,
            };
        //view custom branch//

        //view custom bank list//
        case 'FIND_BRANCH_CUSTOM_BANK_LIST_REQUEST':
            return {
                ...state,
                loadingBranchCustomBankList: true,
                BranchCustomBankList: "",
                BranchCustomBankListError: '',
            };
        case 'FIND_BRANCH_CUSTOM_BANK_LIST_SUCCESS':
            return {
                ...state,
                loadingBranchCustomBankList: false,
                BranchCustomBankList: action.payload,
            };
        case 'FIND_BRANCH_CUSTOM_BANK_LIST_FAILURE':
            return {
                ...state,
                loadingBranchCustomBankList: false,
                BranchCustomBankListError: action.payload,
            };
        //view custom bank list//

        //view custom bank detail//
        case 'FIND_BRANCH_CUSTOM_BANK_DETAIL_REQUEST':
            return {
                ...state,
                loadingBranchCustomBankDetail: true,
                BranchCustomBankDetail: "",
                BranchCustomBankDetailError: '',
            };
        case 'FIND_BRANCH_CUSTOM_BANK_DETAIL_SUCCESS':
            return {
                ...state,
                loadingBranchCustomBankDetail: false,
                BranchCustomBankDetail: action.payload,
            };
        case 'FIND_BRANCH_CUSTOM_BANK_DETAIL_FAILURE':
            return {
                ...state,
                loadingBranchCustomBankDetail: false,
                BranchCustomBankDetailError: action.payload,
            };
        //view custom bank detail//


        //country//
        case 'FIND_BRANCH_COUNTRY_REQUEST':
            return {
                ...state,
                loadingBranchCountryApi: true,
                BranchCountryData: "",
                BranchCountryDataError: '',
            };
        case 'FIND_BRANCH_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingBranchCountryApi: false,
                BranchCountryData: action.payload,
            };
        case 'FIND_BRANCH_COUNTRY_FAILURE':
            return {
                ...state,
                loadingBranchCountryApi: false,
                BranchCountryDataError: action.payload,
            };
        //country//

        //state//
        case 'FIND_BRANCH_STATE_REQUEST':
            return {
                ...state,
                loadingBranchStateApi: true,
                BranchStateData: "",
                BranchStateDataError: '',
            };
        case 'FIND_BRANCH_STATE_SUCCESS':
            return {
                ...state,
                loadingBranchStateApi: false,
                BranchStateData: action.payload,
            };
        case 'FIND_BRANCH_STATE_FAILURE':
            return {
                ...state,
                loadingBranchStateApi: false,
                BranchStateDataError: action.payload,
            };
        //state//

        //city//
        case 'FIND_BRANCH_CITY_REQUEST':
            return {
                ...state,
                loadingBranchCityApi: true,
                BranchCityData: "",
                BranchCityDataError: '',
            };
        case 'FIND_BRANCH_CITY_SUCCESS':
            return {
                ...state,
                loadingBranchCityApi: false,
                BranchCityData: action.payload,
            };
        case 'FIND_BRANCH_CITY_FAILURE':
            return {
                ...state,
                loadingBranchCityApi: false,
                BranchCityDataError: action.payload,
            };
        //city//

        //airport//
        case 'FIND_BRANCH_AIRPORT_REQUEST':
            return {
                ...state,
                loadingBranchAirportApi: true,
                BranchAirportData: "",
                BranchAirportDataError: '',
            };
        case 'FIND_BRANCH_AIRPORT_SUCCESS':
            return {
                ...state,
                loadingBranchAirportApi: false,
                BranchAirportData: action.payload,
            };
        case 'FIND_BRANCH_AIRPORT_FAILURE':
            return {
                ...state,
                loadingBranchAirportApi: false,
                BranchAirportDataError: action.payload,
            };
        //airport//

        //seaport//
        case 'FIND_BRANCH_SEAPORT_REQUEST':
            return {
                ...state,
                loadingBranchSeaportApi: true,
                BranchSeaportData: "",
                BranchSeaportDataError: '',
            };
        case 'FIND_BRANCH_SEAPORT_SUCCESS':
            return {
                ...state,
                loadingBranchSeaportApi: false,
                BranchSeaportData: action.payload,
            };
        case 'FIND_BRANCH_SEAPORT_FAILURE':
            return {
                ...state,
                loadingBranchSeaportApi: false,
                BranchSeaportDataError: action.payload,
            };
        //seaport//

        // <------------More Address----------------->
        //list branch more address//
        case 'FIND_BRANCH_MORE_ADDRESS_LIST_REQUEST':
            return {
                ...state,
                loadingBranchMoreAddressList: true,
                BranchMoreAddressList: [],
                BranchMoreAddressListError: '',
            };
        case 'FIND_BRANCH_MORE_ADDRESS_LIST_SUCCESS':
            return {
                ...state,
                loadingBranchMoreAddressList: false,
                BranchMoreAddressList: action.payload,
            };
        case 'FIND_BRANCH_MORE_ADDRESS_LIST_FAILURE':
            return {
                ...state,
                loadingBranchMoreAddressList: false,
                BranchMoreAddressListError: action.payload,
            };
        //list branch more address//


        //view branch more address//
        case 'FIND_BRANCH_MORE_ADDRESS_DETAIL_REQUEST':
            return {
                ...state,
                loadingBranchMoreAddressDetail: true,
                BranchMoreAddressDetail: "",
                BranchMoreAddressDetailError: '',
            };
        case 'FIND_BRANCH_MORE_ADDRESS_DETAIL_SUCCESS':
            return {
                ...state,
                loadingBranchMoreAddressDetail: false,
                BranchMoreAddressDetail: action.payload,
            };
        case 'FIND_BRANCH_MORE_ADDRESS_DETAIL_FAILURE':
            return {
                ...state,
                loadingBranchMoreAddressDetail: false,
                BranchMoreAddressDetailError: action.payload,
            };
        //view branch more address//


        //acc manager//
        case 'FIND_ACCOUNT_MANAGER_REQUEST':
            return {
                ...state,
                loadingBranchAccManagers: true,
                BranchAccManagersData: "",
                BranchAccManagersDataError: '',
            };
        case 'FIND_ACCOUNT_MANAGER_SUCCESS':
            return {
                ...state,
                loadingBranchAccManagers: false,
                BranchAccManagersData: action.payload,
            };
        case 'FIND_ACCOUNT_MANAGER_FAILURE':
            return {
                ...state,
                loadingBranchAccManagers: false,
                BranchAccManagersDataError: action.payload,
            };
        //acc manager//

        //acc manager detail//
        case 'FIND_BRANCH_ACCOUNT_MANAGER_DETAIL_REQUEST':
            return {
                ...state,
                loadingBranchAccManagerDetail: true,
                BranchAccManagerDetailData: {},
                BranchAccManagerDetailDataError: '',
            };
        case 'FIND_BRANCH_ACCOUNT_MANAGER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingBranchAccManagerDetail: false,
                BranchAccManagerDetailData: action.payload,
            };
        case 'FIND_BRANCH_ACCOUNT_MANAGER_DETAIL_FAILURE':
            return {
                ...state,
                loadingBranchAccManagerDetail: false,
                BranchAccManagerDetailDataError: action.payload,
            };
        //acc manager detail//

        default:
            return state;
    }
}

export default BranchReducer;